import { ChipsideComponent } from "../chipside-component";

export class TreeItem extends ChipsideComponent {
	constructor() {
		super();

		this.identifier = this.getAttribute("identifier");
		this.icon = this.getAttribute("icon") ?? "";
		this.open = this.hasAttribute("open");
	}

	parsedCallback() {
		if (this.querySelector("chip-tree")) {
			const checkboxID = crypto.randomUUID().slice(0, 8);

			const label = document.createElementWithContents("label", [...this.childNodes ?? []].filter(x => x.nodeType === Node.TEXT_NODE), {
				htmlFor: checkboxID
			});

			if (this.icon) {
				label.prepend(document.createElementWithContents("i", null, { className: this.icon }));
			}

			this.prepend(label);

			const input = document.createElementWithContents("input", null, {
				type: "checkbox",
				id: checkboxID
			});

			if (this.open) {
				input.checked = true;
			}

			this.#UpdateOpenState();
			input.onchange = () => this.#UpdateOpenState();

			this.prepend(input);
		} else if (this.icon) {
			if (this.icon) {
				this.prepend(document.createElementWithContents("i", null, { className: this.icon }));
			}
		}
	}

	#UpdateOpenState() {
		this.closest("[role='treeitem']").ariaExpanded = this.querySelector("input")?.checked ?? this.open;
	}
}